import * as types from './action-types';
import api from '../utils/api';
import getAuth from '../utils/get-auth';

/**
 * Request the current users' list of friends.
 */
export const requestFriendsList = () => {
  return (dispatch, getState) => {
    const auth = getAuth(getState());
    dispatch({
      type: types.FRIENDS_REQUEST_LIST,
      payload: api(`/friends`, {
        headers: { 'Authorization': `JWT ${auth}` }
      })
    });
  }
};

/**
 * Create a friend request for a given user. Takes an options hash
 * that has an `email` property that matches an email of a user
 * in Normal Chat.
 *
 * @param {string} email - The email for the user.
 */
export const createFriendRequest = (email) => {
  return (dispatch, getState) => {
    const auth = getAuth(getState());
    dispatch({
      type: types.FRIENDS_REQUEST_ADD_FRIEND,
      payload: api(`/friends`, {
        headers: {
          'Authorization': `JWT ${auth}`,
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          email: email.trim()
        })
      })
    });
  };
};

/**
 * Search for a user. Takes an options hash that has either an
 * `email` or a `token` property.
 *
 * @param {Object} options The options for the search.
 * @param {string} options.email The email to search for.
 * @param {string} options.token The Normal ID to search for.
 */
export const searchForUser = (options) => {
  let { email, token } = options;
  return (dispatch, getState) => {
    const auth = getAuth(getState());
    let path = '/users?';

    if (email) {
      path += `email=${encodeURIComponent(email)}`;
    } else {
      path += `token=${encodeURIComponent(token)}`;
    }

    dispatch({
      type: types.FRIENDS_SEARCH_USER,
      payload: api(path, {
        headers: { 'Authorization': `JWT ${auth}` }
      })
    });
  };
};

/**
 * Clear the search results state for searching for a user.
 */
export const clearSearch = () => {
  return {
    type: types.FRIENDS_CLEAR_SEARCH_USER
  };
};



// WEBPACK FOOTER //
// ./src/actions/friends-actions.js